import { formatNumber } from 'helpers/format.js';
import i18n from 'i18next';
import { isNumber } from 'lodash/fp';
import { initReactI18next } from 'react-i18next';

import resources from './langs/index.js';

const pluralRule = {
  numbers: [1, 2],
  plurals: function (n) {
    // Default french plural
    return Number(n >= 2);
  },
};

export const getTranslationKey = companyCode => {
  switch (companyCode) {
    case 'CAPIFRANCE':
      return 'capifrance';
    case 'OPTIMHOME':
      return 'optimhome';

    default:
      return 'default';
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'default',
    interpolation: {
      escapeValue: false,
    },
    compatibilityJSON: 'v3',
    debug: true,
  })
  .then(() => {
    i18n.services.pluralResolver.addRule('capifrance', pluralRule);
    i18n.services.pluralResolver.addRule('optimhome', pluralRule);
    i18n.services.pluralResolver.addRule('default', pluralRule);

    i18n.services.formatter.add('formatNumber', value => {
      return isNumber(value) ? formatNumber(value) : '';
    });
  });

export default i18n;
